import dayjs from 'utils/dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { pluralise } from 'utils/string';
import { Dayjs } from 'dayjs';

export const getDefaultDateFormat = (date: string) => dayjs(date).format('DD-MM-YYYY');

export const getDifferenceInDates = (date: string) => {
  const dateToday = dayjs();
  const expiryDate = dayjs(date);

  return expiryDate.diff(dateToday, 'day');
};

export const expireSoon = (date: string) => getDifferenceInDates(date) <= 30;

export const dateSentence = (isAlert: boolean, showDate: boolean | undefined, date: string) => {
  const expiry = getDefaultDateFormat(date);
  const expiryGap = getDifferenceInDates(date);
  const dayjsDate = dayjs(date);

  if (dayjsDate.isToday()) {
    return 'Expires Today';
  }

  if (dayjsDate.isTomorrow()) {
    return 'Expires Tomorrow';
  }

  if (!isAlert) {
    return `Expires on ${expiry}`;
  }

  if (showDate) {
    return `Expires in **${expiryGap} ${pluralise('day', expiryGap)}** on ${expiry}`;
  }

  return `Expires in **${expiryGap} ${pluralise('day', expiryGap)}**`;
};

const minAge = 16;
const maxAge = 120;

export type AgeCategory = 'high' | 'low' | 'ok';

export const dateToString = (date: Dayjs) => date.format('YYYY-MM-DD');

export const getAgeCategory = (date: Dayjs | null): AgeCategory => {
  const dayToday = dayjs();

  const dateOfBirthDiff = dayToday.diff(date, 'year');

  const isOverUpperLimit = dateOfBirthDiff > maxAge;
  const isUnderLowerLimit = dateOfBirthDiff < minAge;

  if (isOverUpperLimit) return 'high';
  if (isUnderLowerLimit) return 'low';
  return 'ok';
};

export const dateExpiry = (date: string | undefined) => {
  dayjs.extend(advancedFormat);
  dayjs.extend(customParseFormat);

  return dayjs(date, 'DD/MM/YYYY').format(`Do MMM. YYYY`);
};

export const checkExpiry = (date: string | undefined) => {
  dayjs.extend(customParseFormat);
  const expiry = dayjs(date, 'DD/MM/YYYY').format('YYYY-MM-DD');

  return expireSoon(expiry);
};
